import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { EnvService } from 'src/app/env.service';
import { SlWapiService } from 'src/app/model/api-services/sl-wapi.service';
import { SessionService } from 'src/app/session.service';

@Component({
  selector: 'app-user-badge',
  templateUrl: './user-badge.component.html',
  styleUrls: ['./user-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserBadgeComponent implements OnInit {

  public displayName = '';
  public roleName = '';
  public avatarURL = '';
  public loadingAvatar = true;
  public hasSession = false;
  private _ready: boolean = false;
  constructor(
    private wapi: SlWapiService,
    private session: SessionService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const session = this.wapi.GetSession();
    this.hasSession = !!session;
    this.displayName = session.realname;
    this.roleName = session.role;
    this._ready = true;
    this.Refresh();

  }
  Refresh() {
    if (!this._ready) {
      return;
    }
    this.cdr.detectChanges();
  }

}
